import { Model } from '@vuex-orm/core'
import { UserDto } from './user.interface'
import { Constants } from '@/constants'

export default class User extends Model {
    static entity = 'users'

    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(''),
            name: this.attr('')
        }
    }

    static async createOne(payload: UserDto) {
        return await this.api().post(Constants.API.USER, payload)
    }

    static async findOne(id: number) {
        return await this.api().get(Constants.API.USER + "/" + id)
    }

    static async updateOne(id: number, payload: UserDto) {
        return await this.api().patch(Constants.API.USER + "/" + id, payload)
    }

    static async removeOne(id: number) {
        return await this.api().delete(Constants.API.USER + "/" + id)
    }

    static apiConfig = {
        actions: {
            fetch: {
                method: 'get',
                url: '/users'
            }
        }
    }
}
